export const m010Definition = {
  id: "M-010",
  title: "Protected File Tokens Authorization",
  description:
    "Sequence diagram showing signed token generation for protected files and subsequent authenticated file retrieval.",
  participants: [
    { id: "Client", label: "Client App" },
    { id: "API", label: "Solarch API" },
    { id: "Storage", label: "Storage Driver" },
  ],
  messages: [
    { id: "m1", from: "Client", to: "API", label: "1. POST /api/files/token" },
    { id: "m2", from: "API", to: "Client", label: "2. Signed JWT Token", isResponse: true },
    { id: "m3", from: "Client", to: "API", label: "3. GET /api/files/...?token=JWT" },
    { id: "m4", from: "API", to: "API", label: "4. Verify Token" },
    { id: "m5", from: "API", to: "Storage", label: "5. Fetch File Path" },
    { id: "m6", from: "Storage", to: "API", label: "6. Stream File Binary", isResponse: true },
    { id: "m7", from: "API", to: "Client", label: "7. Return File Stream", isResponse: true },
  ],
};
